var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmenuRigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21967 10.1587C-0.0732233 10.4655 -0.0732233 10.963 0.21967 11.2699C0.512563 11.5767 0.987437 11.5767 1.28033 11.2699L5.78033 6.55559C6.06426 6.25813 6.0742 5.77917 5.80286 5.46908L1.67787 0.754792C1.39797 0.434913 0.923546 0.413303 0.618206 0.706526C0.312867 0.999748 0.29224 1.49677 0.572134 1.81664L4.2119 5.97637L0.21967 10.1587Z",
    fill: "#858795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenuRigh);
export default __webpack_public_path__ + "static/media/submenu-righ.0d567f3d05ffe8811a3b5dc114f2d7bf.svg";
export { ForwardRef as ReactComponent };